import * as React from 'react'
import { withGoogleMap, GoogleMap, Marker, GoogleMapProps, WithGoogleMapProps } from 'react-google-maps'

import * as Types from '../types'
import LocationSearch, { LocationSearchInputProps } from './LocationSearch'

import images from '../images'

interface MapProps extends LocationSearchInputProps {
	markerCoords?: Types.LatLng
	isMarkerShown?: boolean
	zoomNumber: number
	currentLocation?: Types.LatLng
	isMyLocationButtonDisabled?: boolean
	onClick?: (e: any) => void
	onToggleOpen?: (e: any) => void
}

interface MapState {
}

class GMap extends React.Component<MapProps & GoogleMapProps, MapState> {

	constructor(props: any) {
		super(props)
		this.state = {}
	}

	render() {
		return (
			<GoogleMap
				zoom={this.props.zoomNumber}
				center={this.props.isMarkerShown && this.props.markerCoords ? this.props.markerCoords : this.props.currentLocation}
				onClick={this.props.onClick}
			>
				<LocationSearch
					address={this.props.address}
					apartmentNumber={this.props.apartmentNumber}
					isApartmentNumberActive={this.props.isApartmentNumberActive}
					onAddressChange={this.props.onAddressChange}
					onApartmentEnabled={this.props.onApartmentEnabled}
					onApartmentNumberChanged={this.props.onApartmentNumberChanged}
					setCurrentLocation={this.props.setCurrentLocation}
				/>
				{this.props.isMarkerShown && <Marker zIndex={50} position={this.props.markerCoords} onClick={this.props.onToggleOpen} />}
				{this.props.currentLocation && !this.props.isMyLocationButtonDisabled &&
					<Marker
						zIndex={100}
						position={this.props.currentLocation}
						icon={images.myLocation}
						clickable={false}
					/>
				}
			</GoogleMap>
		)
	}
}

export const Map = withGoogleMap(GMap) as React.ComponentClass<MapProps & WithGoogleMapProps>



// WEBPACK FOOTER //
// ./src/components/Map.tsx